import { render, staticRenderFns } from "./InformationRegister.vue?vue&type=template&id=0e049fda&"
import script from "./InformationRegister.vue?vue&type=script&lang=ts&"
export * from "./InformationRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports